import * as terminologyService from '../../../../services/Administration/terminologyService';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: () => terminologyService.editTerminologyLabels
  },
});
